module.exports = require('../../full/symbol');
